import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FAQProps {
  licenseType: string;
  className?: string;
}

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC<FAQProps> = ({ licenseType, className = '' }) => {
  const { t } = useTranslation();
  const [openItems, setOpenItems] = useState<number[]>([]);

  const getFAQItems = (): FAQItem[] => {
    switch (licenseType) {
      case 'freshdesk':
        return [
          {
            question: t('freshdesk.faq.question1.question'),
            answer: t('freshdesk.faq.question1.answer')
          },
          {
            question: t('freshdesk.faq.question2.question'),
            answer: t('freshdesk.faq.question2.answer')
          },
          {
            question: t('freshdesk.faq.question3.question'),
            answer: t('freshdesk.faq.question3.answer')
          },
          {
            question: t('freshdesk.faq.question4.question'),
            answer: t('freshdesk.faq.question4.answer')
          },
          {
            question: t('freshdesk.faq.question5.question'),
            answer: t('freshdesk.faq.question5.answer')
          },
          {
            question: t('freshdesk.faq.question6.question'),
            answer: t('freshdesk.faq.question6.answer')
          },
          {
            question: t('freshdesk.faq.question7.question'),
            answer: t('freshdesk.faq.question7.answer')
          },
          {
            question: t('freshdesk.faq.question8.question'),
            answer: t('freshdesk.faq.question8.answer')
          }
        ];
      case 'content_master':
        return [
          {
            question: t('content_master.faq.question1.question'),
            answer: t('content_master.faq.question1.answer')
          },
          {
            question: t('content_master.faq.question2.question'),
            answer: t('content_master.faq.question2.answer')
          },
          {
            question: t('content_master.faq.question3.question'),
            answer: t('content_master.faq.question3.answer')
          },
          {
            question: t('content_master.faq.question4.question'),
            answer: t('content_master.faq.question4.answer')
          },
          {
            question: t('content_master.faq.question5.question'),
            answer: t('content_master.faq.question5.answer')
          },
          {
            question: t('content_master.faq.question6.question'),
            answer: t('content_master.faq.question6.answer')
          }
        ];
      case 'shipment_tracker':
        return [
          {
            question: t('shipment_tracker.faq.question1.question'),
            answer: t('shipment_tracker.faq.question1.answer')
          },
          {
            question: t('shipment_tracker.faq.question2.question'),
            answer: t('shipment_tracker.faq.question2.answer')
          },
          {
            question: t('shipment_tracker.faq.question3.question'),
            answer: t('shipment_tracker.faq.question3.answer')
          },
          {
            question: t('shipment_tracker.faq.question4.question'),
            answer: t('shipment_tracker.faq.question4.answer')
          }
        ];
      case 'gpsr':
        return [];
      case 'mobile':
        return [];
      default:
        return [];
    }
  };

  const toggleItem = (index: number) => {
    setOpenItems(prev => 
      prev.includes(index) 
        ? prev.filter(item => item !== index)
        : [...prev, index]
    );
  };

  const faqItems = getFAQItems();

  if (faqItems.length === 0) {
    return null;
  }

  return (
    <div className={`faq ${className}`}>
      <div className="faq-container">
        <h2 className="block-title">{t(`${licenseType}.faq.title`)}</h2>
        <div className="faq-list">
          {faqItems.map((item, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openItems.includes(index) ? 'open' : ''}`}
                onClick={() => toggleItem(index)}
              >
                <span className="faq-question-text">{item.question}</span>
                <span className="faq-arrow">{openItems.includes(index) ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openItems.includes(index) ? 'open' : ''}`}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
